// Generated by purs version 0.13.8
"use strict";
var Lib_Packages_Gatsby_Img = require("/usr/src/app/www/src/Lib/Packages/Gatsby/Image.purs");
var Lib_Utils_Typography = require("/usr/src/app/www/src/Lib/Utils/Typography.purs");
var React_Basic_DOM = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM.purs");
var React_Basic_DOM_Generated = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM/Generated.purs");
var React_Basic_DOM_Internal = require("/usr/src/app/www/.spago/react-basic-dom/v2.0.0/src/React/Basic/DOM/Internal.purs");
var bio = function (props) {
    return React_Basic_DOM_Generated.div()({
        style: React_Basic_DOM_Internal.css({
            display: "flex",
            marginBottom: Lib_Utils_Typography.rhythm(2.5)
        }),
        children: [ Lib_Packages_Gatsby_Img.img({
            fixed: props.avatar.childImageSharp.fixed,
            alt: props.site.siteMetadata.author.name,
            style: React_Basic_DOM_Internal.css({
                marginRight: Lib_Utils_Typography.rhythm(1.0 / 2.0),
                marginBottom: 0,
                minWidth: 50,
                borderRadius: "100%"
            }),
            imgStyle: {
                borderRadius: "50%"
            }
        }), React_Basic_DOM_Generated.p_([ React_Basic_DOM.text("Written by "), React_Basic_DOM_Generated.strong_([ React_Basic_DOM.text(props.site.siteMetadata.author.name) ]), React_Basic_DOM.text(" " + (props.site.siteMetadata.author.summary + " ")), React_Basic_DOM_Generated.a()({
            href: "https://twitter.com/" + props.site.siteMetadata.social.twitter,
            children: [ React_Basic_DOM.text("You should follow him on Twitter") ]
        }) ]) ]
    });
};
module.exports = {
    bio: bio
};

